import { Modal } from "@/components/Modal"
import Stepper from "@/components/Stepper"
import StepperSection from "@/components/Stepper/StepperSection"
import type { EntityLocked, SHARED_DATA_TYPE_VALUE } from "@/domain/sharedData/constants"
import { ModalBody } from "@chakra-ui/react"
import { FormattedMessage, useIntl } from "react-intl"
import { CreationMultiStepFormProvider } from "./context/ShareRequestInterbuCreateModalContext"
import ClientStep from "./steps/ClientStep"
import ProjectStep from "./steps/ProjectStep"
import RecipientStep from "./steps/RecipientStep"

type Props = {
  isOpen: boolean
  onClose: () => void
  sharedEntity?: EntityLocked & { type: SHARED_DATA_TYPE_VALUE }
}

export const ShareRequestInterbuCreateModal: React.FC<Props> = ({
  isOpen,
  onClose,
  sharedEntity,
}) => {
  const intl = useIntl()
  const steps = [
    { label: intl.formatMessage({ id: "userSharedData.interbu.modal.steps.0.title" }) },
    { label: intl.formatMessage({ id: "userSharedData.interbu.modal.steps.1.title" }) },
    { label: intl.formatMessage({ id: "userSharedData.interbu.modal.steps.2.title" }) },
  ]

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<FormattedMessage id="userSharedData.interbu.modal.title" />}
      size="6xl"
    >
      <ModalBody>
        <CreationMultiStepFormProvider sharedEntity={sharedEntity}>
          <Stepper steps={steps} stepWidth={40}>
            <StepperSection index={0}>
              <ClientStep />
            </StepperSection>
            <StepperSection index={1}>
              <ProjectStep />
            </StepperSection>
            <StepperSection index={2}>
              <RecipientStep onClose={onClose} />
            </StepperSection>
          </Stepper>
        </CreationMultiStepFormProvider>
      </ModalBody>
    </Modal>
  )
}
